<div class="container">
  <div *ngIf="fileUploadMode !== ENFILEUPLOADMODE.webcam" class="top-bar">
    <button
      mat-button
      type="button"
      class="btn btn-back"
      (click)="onCloseClick($event)"
    >
      <mat-icon class="icn-back" style="align-content: center">
        arrow_back_ios
      </mat-icon>
      VOLTAR
    </button>
  </div>

  <ng-container [ngSwitch]="fileUploadMode">
    <div class="single" *ngSwitchCase="ENFILEUPLOADMODE.single">
      <lib-cmp-file-upload-selector
        (afterFileUpload)="afterFileUpload($event)"
        (afterOpenWebcam)="afterOpenWebcam($event)"
        (afterChooseFile)="afterChooseFileSingle($event)"
        [acceptFiles]="acceptSingleFiles"
        [data]="data"
        [enFileUploadMode]="fileUploadMode"
        [show]="!showList"
      >
      </lib-cmp-file-upload-selector>
    </div>

    <!-- FILE LIST AND UPLOAD OPTIONS -->
    <div class="file-list" [style]="fileUploadMode == ENFILEUPLOADMODE.webcam ? 'height: auto' : ''" *ngSwitchDefault>
      <lib-cmp-file-upload-selector
        (afterFileUpload)="afterFileUpload($event)"
        (afterOpenWebcam)="afterOpenWebcam($event)"
        (afterChooseFile)="afterChooseFile($event)"
        [data]="data"
        [enFileUploadMode]="fileUploadMode"
        [show]="!showList"
      >
      </lib-cmp-file-upload-selector>

      <div class="table" *ngIf="showList">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let element">
              {{ element.DocumentoNo }}
            </td>
          </ng-container>

          <ng-container matColumnDef="documento">
            <th mat-header-cell *matHeaderCellDef>Documento</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="editingId !== element.DocumentoNo">
                {{ element.DocumentoNomeExibicao }}
              </span>

              <input *ngIf="editingId == element.DocumentoNo"
                type="text"
                id="filename-input"
                class="filename-input"
                [(ngModel)]="fileName"
                pattern="[A-Za-z0-9\-_.\(\) ]+ "
                name="filename-input"
                title="Use apenas letras, números, espaço, -, _, ., (, )"
                required
              />
            </td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ extractIconName(element) }} </mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="tamanho">
            <th mat-header-cell *matHeaderCellDef>Tamanho</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Tamanho }}
            </td>
          </ng-container>

          <ng-container matColumnDef="versao">
            <th mat-header-cell *matHeaderCellDef>Versão</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Versao }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td class="hud-btns-td" mat-cell *matCellDef="let element">
              <!-- Quando NÃO está editando essa linha -->
              <ng-container *ngIf="editingId !== element.DocumentoNo">
                <!-- <button
                  class="btn-actions"
                  type="button"
                  title="Renomear Arquivo"
                  (click)="editingId = element.DocumentoNo; fileName = element.DocumentoNomeExibicao"
                >
                  <mat-icon>edit</mat-icon>
                </button> -->

                <button
                  class="btn-actions"
                  type="button"
                  title="Visualizar Arquivo"
                  *ngIf="canPreview(element)"
                  (click)="onPreview(element)"
                >
                  <mat-icon>visibility</mat-icon>
                </button>

                <button
                  class="btn-actions"
                  type="button"
                  title="Download"
                  (click)="onDownload(element)"
                >
                  <mat-icon>download</mat-icon>
                </button>

                <button
                  class="btn-actions delete"
                  type="button"
                  title="Apagar Arquivo"
                  (click)="onDelete(element)"
                >
                  <mat-icon class="mat-18">delete_forever</mat-icon>
                </button>
              </ng-container>

              <!-- Quando ESTÁ editando essa linha -->
              <!-- <ng-container *ngIf="editingId === element.DocumentoNo">
                <button
                  class="btn-actions btn-edit"
                  type="button"
                  title="Salvar"
                  (click)="editFileName(element)"
                >
                  Salvar
                </button>

                <button
                  class="btn-actions btn-cancelar"
                  type="button"
                  title="Cancelar"
                  (click)="editingId = null"
                >
                  Cancelar
                </button>
              </ng-container> -->
            </td>
          </ng-container>


          <ng-container matColumnDef="noRecords">
            <td mat-footer-cell *matFooterCellDef>
              <span *ngIf="!isLoading"> Nenhum documento encontrado. </span>

              <span *ngIf="isLoading" class="file-list-loading">
                <mat-spinner
                  [diameter]="35"
                  [strokeWidth]="4"
                  mode="indeterminate"
                ></mat-spinner>
              </span>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="
              dataSource && dataSource.data.length ? displayedColumns : []
            "
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr
            mat-footer-row
            *matFooterRowDef="
              dataSource && dataSource.data.length ? [] : ['noRecords']
            "
            colspan="6"
          ></tr>
        </table>
      </div>
    </div>

    <div *ngIf="!showList">
      <div class="img-view" *ngSwitchCase="ENFILEUPLOADMODE.preview">
        <p style="text-align: center" class="nome-foto">
          {{ selectedDocument.DocumentoNomeExibicao }}
        </p>

        <img
          [style.height]="600 + 'px'"
          [src]="selectedDocument.CaminhoFisico"
          [alt]="selectedDocument.DocumentoNomeExibicao"
        />

        <div class="hub-btns">
          <button
            style="margin-right: 8px"
            class="btn btn-primary"
            type="button"
            (click)="onPreviewBack($event)"
          >
            Fechar
          </button>

          <button
            style="margin-right: 8px"
            class="btn btn-primary"
            type="button"
            (click)="onDownload(selectedDocument)"
          >
            Baixar
          </button>

          <button
            class="btn btn-danger"
            type="button"
            (click)="onDelete(selectedDocument)"
          >
            Excluir
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
